import { createApiClient } from "@ronin/api-client";
import { queryOptions } from "@tanstack/react-query";
import { isNative } from "./platform/native.js";
import { serverUrl } from "./platform/server.js";
import { nativeTokens } from "./platform/tokens.js";

// Web: same origin, the API is served under /api by the same host (Vite proxies it in dev).
// Android app (spec08): the server the user entered, with a bearer token instead of cookies.
// spec11 FR14: requests fail at once while the device knows it is offline.
const online = () => navigator.onLine;
export const api = createApiClient(
  isNative ? { baseUrl: serverUrl, tokens: nativeTokens, online } : { online },
);

export const authStatusQuery = queryOptions({
  queryKey: ["auth", "status"],
  queryFn: () => api.auth.session(),
  staleTime: 60_000,
  // Offline it fails at once (the app then starts from its offline copy, spec11 FR16).
  networkMode: "always",
});
